export const LFCONNECT_URLS = {
    sandbox: 'https://vtqa.lfconnect.com',
    production: 'https://halo.fitness',
    sandbox_api: 'https://api-vtqa.halo.fitness/partnerapi',
    production_api: 'https://api.halo.fitness/partnerapi',
}



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/GettingStarted/Web/GettingStartedConstants.js